import CommerceSelector from "@main/commerces/components/CommerceSelector";
import EventTypeSelector from "@main/event-types/components/EventTypeSelector";
import EventSelector from "@main/events/components/EventSelector";
import RoomSelector from "@main/rooms/components/RoomSelector";

const filterUIConfig = {
  uiScheme: {
    classNames: "filters-container",
    // customer_id: {
    //     "ui:widget": "customer-selector",
    //     "ui:options": {
    //         label: false, // Oculta el título del campo
    //     }
    // },
    // report_id: {
    //     "ui:widget": "report-selector",
    //     "ui:options": {
    //         label: false // Oculta el título del campo
    //     }
    // }
    event_id: {
      "ui:widget": "event-selector",      
    },
    start_date: {
      "ui:options": {
        label: true, // Oculta el título del campo
        placeholder: "Desde",
        title: "Desde",
      },
    },
    end_date: {
      "ui:options": {
        label: true, // Oculta el título del campo
        placeholder: "Hasta",
        title: "Hasta",
      },
    },
  },
  widgets: {
    "event-selector": EventSelector,
    // 'report-selector': ReportSelector,
    // 'customer-selector': CustomerSelector
  },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
